import React from 'react';
import './PlayerInfo.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons';
const PlayerInfo = (props) => {
    const{name, image, goal, marketValue, position, citizenship} = props.player;
    return (
        
    <div className="card cardStyle">
        <div className="row no-gutters">
            <div className="col-auto imgStyle">
                <img src={image} className="img-fluid" alt=""></img>
            </div>
            <div className="col ml-2">
                <div className="card-block px-2 border-left mt-3">
                    <h5 className="card-title">Name: {name}</h5>
                    <p className="card-text">Position: {position}</p>
                    <p className="card-text">Caps/Goals: {goal}</p>
                    <p className="card-text">Citizenship: {citizenship}</p>
                    <p className="card-text">Market-Value: € {marketValue} million</p>
                    <button id="btnStyle" className="mb-5" onClick={()=> props.handleAddPlayer(props.player)} href="#" ><FontAwesomeIcon icon={faUserPlus}/> Player</button>
                </div>
            </div>
        </div>
    </div>
    );
};

export default PlayerInfo;